import indexedDBStorage from '@/server/storages/indexDB'
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

export const useMacbookStore = create(
  persist(
    immer(set => ({
      isLidExpanded: false,
      scrollYProgress: 0,
      toggleLid: () =>
        set(state => {
          state.isLidExpanded = !state.isLidExpanded
        }),
      setIsLidExpanded: expanded =>
        set(state => {
          state.isLidExpanded = expanded
        }),
      setScrollYProgress: progress =>
        set(state => {
          state.scrollYProgress = progress
        })
    })),
    {
      name: 'scroll-2D', // Clave bajo la cual se guarda el estado en IndexedDB
      storage: createJSONStorage(() => indexedDBStorage),
      // Opcional: Especificar qué partes del estado persistir.
      // Si scrollYProgress no necesita ser persistido (ya que se actualiza al cargar),
      // se puede excluir para optimizar.
      // partialize: (state) => ({ isLidExpanded: state.isLidExpanded }),
      onRehydrateStorage: state => {
        try {
          // Attempt to rehydrate. The `state` argument is the persisted state.
          // If there's an issue with the persisted state or the rehydration process,
          // an error might be thrown by Zustand's persist middleware internally
          // or by your custom logic if you add any here.
          if (state === undefined) {
            console.warn('No persisted state found in IndexedDB for macbook-ui-state.')
          }
        } catch (error) {
          console.error('Error during onRehydrateStorage:', error)
          // You can add more specific error handling here if needed,
          // for example, resetting to a default state or notifying the user.
        }
        // The function should return void or a Promise<void>
        // It's primarily for side effects after rehydration.
      }
    }
  )
)
